<template>
  <v-container fluid class="px-lg-5">
    <app-header :title="title" :breadcrumbs="breadcrumbs" :showButton="false" />
    <table-filter @filterTable="onYearFilter" :items="yearOptions"
      :label="$t('models.appraisal.attributes.year')" />
    <v-card class="rounded-card" flat outlined>
      <v-data-table :headers="headers" :items="appraisals.items" :options.sync="options"
        @update:options="updateOptions" :server-items-length="appraisals.count" :loading="loading"
        :no-data-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })"
        :no-results-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })" flat>
        <template v-slot:item="{ item }">
          <tr :class="{ 'appraisal-row--clickable': isClickable(item) }" @click="openAppraisal(item)">
            <td>{{ item.employeeName }}</td>
            <td>{{ item.title }}</td>
            <td>
              <v-chip small :color="statusColors[item.status]" text-color="white">
                {{ $t(`models.appraisal.attributes.statuses.${item.status}`) }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {appraisalStatuses, appraisalStatusColors} from 'constants';

export default {
  name: 'ManageAppraisals',
  data() {
    const currentYear = new Date().getFullYear();
    return {
      yearOptions: [currentYear, currentYear - 1, currentYear - 2],
      statusColors: appraisalStatusColors,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        mustSort: ['true'],
        multiSort: false,
        filterBy: {
          year: currentYear
        }
      },
      title: {
        text: this.$t('layout.mainMenu.manageAppraisals'),
        icon: 'mdi-clipboard-text-outline'
      },
      breadcrumbs: [
        {
          text: this.$t('layout.mainMenu.home'),
          to: {name: 'Home'}
        },
        {
          text: this.$t('layout.mainMenu.manageAppraisals'),
          to: {name: 'ManageAppraisals'},
          exact: true
        }
      ],
      headers: [
        {
          text: this.$t('models.appraisal.attributes.employee'),
          value: 'employeeName',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.title'),
          value: 'title',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.status'),
          value: 'status',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['appraisals', 'currentUser'])
  },
  methods: {
    ...mapActions(['getAppraisals']),
    updateOptions(options) {
      this.loading = true;
      this.getAppraisals({...options, filterBy: {...options.filterBy, supervisorId: this.currentUser.id}})
        .then(() => (this.loading = false));
    },
    onYearFilter(year) {
      this.options.page = 1;
      this.options.filterBy.year = year;
      this.updateOptions(this.options);
    },
    isClickable(appraisal) {
      return appraisal.status !== appraisalStatuses.PENDING_EMPLOYEE;
    },
    openAppraisal(appraisal) {
      if (!this.isClickable(appraisal)) {
        return;
      }
      this.$router.push({name: 'Appraisal', params: {id: appraisal.id}});
    }
  }
};
</script>

<style>
.appraisal-row--clickable {
  cursor: pointer;
}

.appraisal-row--clickable .v-chip {
  cursor: pointer;
}
</style>
